// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1wgdT","label":"Completed_label__2AJSp"};